export default __webpack_public_path__ + "static/media/logo-small.67a1231b.png";